export const GROUP_COORDINATOR_DESCRIPTION =
  'Group Coordinators are able to add and remove ' +
  'users from their group and manage the technical ' +
  'settings on Flexboxes within their group ' +
  'including applying credits were applicable';
